import Vue from 'vue';
import './resources/firebase'
import App from './App.vue';
import router from './routes/router';
import Argon from './plugins/argon-kit';
import VueMeta from 'vue-meta';
import store from './store/store'
import helpers from './helpers/helpers';

Vue.config.productionTip = false;

const helperPlugin = {
	install() {
		Vue.helpers = helpers;
		Vue.store = store
		Vue.prototype.$helpers = helpers;
		Vue.prototype.$store = store
	},
};

Vue.use(helperPlugin);
Vue.use(Argon);
Vue.use(VueMeta, {});

new Vue({
	el: '#app',
	router,
	render: (h) => h(App),
});
